import React from "react";

// Stylised "Before" — old, plain, no plan
export const OldHouseSVG = ({ className = "" }) => (
  <svg
    viewBox="0 0 320 200"
    className={className}
    role="img"
    aria-label="Old style village house"
  >
    <defs>
      <linearGradient id="oldSky" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#E2D9C5" />
        <stop offset="100%" stopColor="#D9CDB2" />
      </linearGradient>
      <pattern id="brick" width="14" height="8" patternUnits="userSpaceOnUse">
        <rect width="14" height="8" fill="#B8896A" />
        <path d="M0 8 H14 M7 0 V4 M0 4 H7" stroke="#9B6E4F" strokeWidth="0.6" />
      </pattern>
    </defs>
    {/* Sky */}
    <rect width="320" height="200" fill="url(#oldSky)" />
    {/* Ground */}
    <rect y="160" width="320" height="40" fill="#B59B6E" />
    {/* Far hill */}
    <path d="M0 165 Q70 130 150 158 T320 155 V200 H0 Z" fill="#A38A5C" opacity="0.6" />
    {/* House body (asymmetric) */}
    <rect x="60" y="90" width="180" height="75" fill="url(#brick)" />
    {/* Sloped roof (corrugated) */}
    <polygon points="50,90 250,90 230,60 70,60" fill="#8B5A3C" />
    <path
      d="M55 88 H245 M70 78 H230 M85 68 H215"
      stroke="#6B3F22"
      strokeWidth="1"
      opacity="0.5"
    />
    {/* Crooked door */}
    <rect x="135" y="115" width="32" height="50" fill="#6B3F22" />
    <rect x="135" y="115" width="32" height="50" fill="none" stroke="#3D2615" strokeWidth="1.5" />
    {/* Small windows */}
    <rect x="80" y="110" width="26" height="22" fill="#3D2615" />
    <path d="M93 110 V132 M80 121 H106" stroke="#1F1108" strokeWidth="1" />
    <rect x="200" y="110" width="26" height="22" fill="#3D2615" />
    <path d="M213 110 V132 M200 121 H226" stroke="#1F1108" strokeWidth="1" />
    {/* Cracks */}
    <path
      d="M70 110 L78 130 L74 145"
      stroke="#7A4F35"
      strokeWidth="1"
      fill="none"
    />
    <path
      d="M225 100 L233 120"
      stroke="#7A4F35"
      strokeWidth="1"
      fill="none"
    />
    {/* Water tank (drum) */}
    <ellipse cx="55" cy="58" rx="10" ry="3" fill="#6E6E6E" />
    <rect x="45" y="48" width="20" height="12" fill="#8A8A8A" />
    <ellipse cx="55" cy="48" rx="10" ry="3" fill="#9E9E9E" />
    {/* Sad cloud */}
    <ellipse cx="60" cy="30" rx="22" ry="8" fill="#FFFFFF" opacity="0.5" />
  </svg>
);

// Stylised "After" — modern, premium, city-like
export const ModernHouseSVG = ({ className = "" }) => (
  <svg
    viewBox="0 0 320 200"
    className={className}
    role="img"
    aria-label="Modern Mera Naksha home"
  >
    <defs>
      <linearGradient id="newSky" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#E6ECF5" />
        <stop offset="100%" stopColor="#F8E6A8" />
      </linearGradient>
      <linearGradient id="wallG" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#FFFFFF" />
        <stop offset="100%" stopColor="#EDEFF3" />
      </linearGradient>
      <linearGradient id="accent" x1="0" x2="1" y1="0" y2="0">
        <stop offset="0%" stopColor="#0B2545" />
        <stop offset="100%" stopColor="#1B4A82" />
      </linearGradient>
    </defs>
    {/* Sky */}
    <rect width="320" height="200" fill="url(#newSky)" />
    {/* Sun */}
    <circle cx="270" cy="42" r="14" fill="#D4A537" />
    <circle cx="270" cy="42" r="20" fill="#D4A537" opacity="0.18" />
    {/* Ground */}
    <rect y="170" width="320" height="30" fill="#CFD7E0" />
    <rect y="168" width="320" height="3" fill="#0B2545" opacity="0.18" />

    {/* Ground floor */}
    <rect x="50" y="100" width="220" height="70" fill="url(#wallG)" stroke="#0B2545" strokeWidth="1" />
    {/* Upper floor (slightly inset) */}
    <rect x="60" y="55" width="200" height="50" fill="url(#wallG)" stroke="#0B2545" strokeWidth="1" />
    {/* Parapet */}
    <rect x="55" y="50" width="210" height="6" fill="#0B2545" />
    {/* Accent vertical strip (modern elevation) */}
    <rect x="195" y="55" width="22" height="115" fill="url(#accent)" />
    <rect x="200" y="60" width="12" height="12" fill="#D4A537" rx="1" />
    <rect x="200" y="80" width="12" height="12" fill="#D4A537" rx="1" />
    <rect x="200" y="100" width="12" height="12" fill="#D4A537" rx="1" />
    <rect x="200" y="120" width="12" height="12" fill="#D4A537" rx="1" />
    {/* Big upper window */}
    <rect x="80" y="65" width="55" height="30" fill="#0B2545" rx="2" />
    <path d="M107.5 65 V95 M80 80 H135" stroke="#D4A537" strokeWidth="1.2" />
    {/* Balcony */}
    <rect x="75" y="95" width="80" height="6" fill="#0B2545" />
    <path
      d="M78 96 V108 M86 96 V108 M94 96 V108 M102 96 V108 M110 96 V108 M118 96 V108 M126 96 V108 M134 96 V108 M142 96 V108 M150 96 V108"
      stroke="#0B2545"
      strokeWidth="1"
    />
    <rect x="75" y="106" width="80" height="3" fill="#D4A537" />
    {/* Door (gold accent) */}
    <rect x="100" y="125" width="32" height="45" fill="#0B2545" />
    <rect x="100" y="125" width="32" height="45" fill="none" stroke="#D4A537" strokeWidth="1.5" />
    <circle cx="127" cy="148" r="1.5" fill="#D4A537" />
    {/* Ground floor windows */}
    <rect x="150" y="120" width="38" height="28" fill="#0B2545" rx="2" />
    <path d="M169 120 V148 M150 134 H188" stroke="#D4A537" strokeWidth="1" />
    {/* Pillar */}
    <rect x="60" y="100" width="6" height="70" fill="#0B2545" />
    <rect x="58" y="100" width="10" height="4" fill="#D4A537" />
    <rect x="58" y="166" width="10" height="4" fill="#D4A537" />
    {/* Plant */}
    <circle cx="40" cy="160" r="8" fill="#4E6C50" />
    <rect x="36" y="160" width="8" height="10" fill="#6B4226" />
    {/* Window planter */}
    <rect x="78" y="93" width="60" height="3" fill="#4E6C50" />

    {/* Subtle "Naksha" stamp */}
    <g transform="translate(232,128)" opacity="0.95">
      <circle r="14" fill="#D4A537" />
      <text
        x="0"
        y="4"
        textAnchor="middle"
        fontSize="9"
        fontWeight="700"
        fill="#0B2545"
      >
        ★
      </text>
    </g>
  </svg>
);
